module.exports = __webpack_public_path__ + "img/markerBusRed.d53aec86.svg";